import { render, staticRenderFns } from "./DynamicReceipt.vue?vue&type=template&id=e8b12e38&scoped=true"
import script from "./DynamicReceipt.vue?vue&type=script&lang=js"
export * from "./DynamicReceipt.vue?vue&type=script&lang=js"
import style0 from "./DynamicReceipt.vue?vue&type=style&index=0&id=e8b12e38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b12e38",
  null
  
)

export default component.exports